import { getRefundAdminGuidance } from "../../../../../data/flight/order/getRefundAdminGuidance";

function PricingSectionRejected({ data }) {
  const { statusLabel, description } = getRefundAdminGuidance(data);

  return (
    <div className="w-full border h-fit border-gray-200 rounded-xl overflow-hidden bg-white mt-4 p-4">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold text-gray-900">Refund</h2>
      </div>
      <div className="bg-red-100 border border-red-400 px-4 w-fit rounded-md min-h-8 py-1 flex items-center justify-center text-red-600 text-sm">
        {statusLabel}
      </div>
      <p className="text-sm text-gray-700 mt-3">{description}</p>
      {data?.rejectReason ? (
        <div className="w-full flex flex-col gap-1 mt-4">
          <span className="font-bold text-sm">Reason</span>
          <span className="text-sm">{data.rejectReason}</span>
        </div>
      ) : null}
    </div>
  );
}

export default PricingSectionRejected;
